<div id="earn-tab-history">
  <div class="tw-flex tw-w-full tw-px-6 tw-py-5">
    <h3>Published History</h3>
  </div>
  <div class="tw-flex tw-flex-col tw-w-full tw-gap-10">
    <app-ag-grid-table
      [options]="versionTable?.options"
      [data]="versionTable?.data()"
      [hasBottomBorder]="true"
      [hasTopBorder]="true"
      [hasHeader]="true"
    />
  </div>
</div>
